import { useCallback } from "react";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useHotelInfoI18nAddress } from "./use-address";

import type { HotelSettingsHotelInfoI18nFormModelOnSetViewModelType } from "..";
import type { HotelSettingsHotelInfoI18nFormModelAddressMethodsType } from "./use-address";
import type { HotelSettingsHotelInfoI18nFormModel } from "../../../type";

type Props = {
	viewModel: HotelSettingsHotelInfoI18nFormModel["ViewModel"];
	onSetViewModel: HotelSettingsHotelInfoI18nFormModelOnSetViewModelType;
	lang: LangCode;
};

export type HotelSettingsHotelInfoI18nFormModelMethodsType = {
	hotelSettingsHotelInfoFormModelMethods: {
		onSetName: (name: string) => void;
		onSetCatchCopy: (name: string) => void;
	};
} & HotelSettingsHotelInfoI18nFormModelAddressMethodsType;

export const useHotelSettingsHotelInfoI18nFormModelMethods = ({
	viewModel,
	onSetViewModel,
	lang,
}: Props): HotelSettingsHotelInfoI18nFormModelMethodsType => {
	const onSetName = useCallback(
		(name: string) => {
			onSetViewModel([
				{
					key: "name",
					value: {
						isEdited: true,
						value: name,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	const onSetCatchCopy = useCallback(
		(catchCopy: string) => {
			onSetViewModel([
				{
					key: "catchCopy",
					value: {
						isEdited: true,
						value: catchCopy,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		hotelSettingsHotelInfoFormModelMethods: {
			onSetName,
			onSetCatchCopy,
		},

		...useHotelInfoI18nAddress({ viewModel, onSetViewModel, lang }),
	};
};
